import BannerUserInfosDeviceAccountsCount from './BannerUserInfosDeviceAccountsCount';
import BannerUserInfosWarning from './BannerUserInfosWarning';
import { GenderEnum, VerifStatusEnum } from '@/lib/enum';
import BannerUserInfos from './BannerUserInfos';
import { TUsernameProps } from '../Username';
import { IHasClassName } from '@/interfaces';
import { CountryEnum } from '@/enums';

export default BannerUserInfos;

interface IUser {
  deviceAccountsCount?: number;
  birthdate?: Date | string;
  countryIso3?: CountryEnum;
  deviceBanCount?: number;
  incognito?: boolean;
  gender: GenderEnum;
  username: string;
  coins?: number;
  email: string;
  _id: string;
  diamondWallet?: {
    coins?: number;
  };
  verifications?: {
    id?: {
      status: VerifStatusEnum;
    };
  };
}

export type TProps = IHasClassName &
{
  enableClickToRedirectToProfile?: boolean;
  useSingleCharGender?: boolean;
  countWarningReceived?: number;
  onClick?: (user: IUser) => void;
  hideEmail?: boolean;
  usernameProps?: TUsernameProps;
  genderProps?: IHasClassName;
  user: IUser;
}

export {
  BannerUserInfosDeviceAccountsCount,
  BannerUserInfosWarning
};
